import noop from 'lodash/noop';
import React from 'react';

import ActionButton from 'components/shared/Buttons/ActionButton';
import BaseModal from 'components/shared/Modal/BaseModal';
import { Spinner } from '@trp-beacon-ui-kit/react-communication';
import {
  sendCancelPendingTransaction,
  captureCancelPendingTransactionBusinessEvent,
  getPendingTransactions
} from 'services/Rest';
import { REQUEST_STATE_REQUESTED } from 'state/requests/RequestStatusReducer';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import { buildBusinessEvent } from 'services/Transactions';

const ActionButtonWithPermissions = WithUserPermissions(ActionButton);
const CancelConfirmationModal = ({
  confirmationNumber,
  closeModal,
  requestStatus,
  standardModalProps,
  allPendingTransactions,
  customer,
  customerEmail,
  view
}) => {
  const handleClick = () => {
    const event = buildBusinessEvent(
      allPendingTransactions,
      view,
      confirmationNumber,
      customer,
      customerEmail
    );
    sendCancelPendingTransaction(confirmationNumber, () => {
      captureCancelPendingTransactionBusinessEvent(event);
      getPendingTransactions();
    });
  };

  return (
    <BaseModal
      containerClassName="cancel-transaction-modal"
      {...standardModalProps}
      title="Are you sure you want to cancel this pending transaction?">
      <div className="modal-body" id="e2e-cancel-confirmation-modal">
        <a
          className="link-action-button responsive-modal-button"
          id="e2e-cancel-action"
          onClick={
            requestStatus === REQUEST_STATE_REQUESTED ? noop : closeModal
          }
          type="secondary">
          No, Close
        </a>
        <ActionButtonWithPermissions
          className="responsive-modal-button"
          id="e2e-confirm-action"
          styleOverride={{ display: 'flex' }}
          onClick={() => handleClick()}
          type="primary"
          shouldDisable>
          {requestStatus === REQUEST_STATE_REQUESTED ? (
            <Spinner />
          ) : (
            'Yes, Cancel'
          )}
        </ActionButtonWithPermissions>
      </div>
    </BaseModal>
  );
};

export default CancelConfirmationModal;
